import React, {Fragment} from "react";
import {Col, FormGroup, Label, Row} from "reactstrap";


const ProductSizeForm = (props) => {
    const {
        errors,
        control,
        register,
        setValue,
        trigger,
        getValues,
        searchSellersByName,
        sellers,
        setOptions,
        promiseOptions
    } = props;


    return (
        <Fragment>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">Size Name<span style={{color :"red"}}>*</span></Label>
                        <input name="name" type="text" {...register('name')} className={`form-control ${errors.name ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.name?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">UK Size<span style={{color :"red"}}>*</span></Label>
                        <input name="uk_size" type="text" {...register('uk_size')}
                               className={`form-control ${errors.uk_size ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.uk_size?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">US Size<span style={{color :"red"}}>*</span></Label>
                        <input name="us_size" type="text" {...register('us_size')}
                               className={`form-control ${errors.us_size ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.us_size?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <FormGroup>
                        <Label className="col-form-label">EU Size<span style={{color :"red"}}>*</span></Label>
                        <input name="eu_size" type="text" {...register('eu_size')}
                               className={`form-control ${errors.eu_size ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.eu_size?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
        </Fragment>
    );
};

export default ProductSizeForm;
